import { apiClient, createAuthHeaders } from '../api-client';
import type {
  OptisignsAssetItem,
  OptisignsFolderItem,
} from '@/lib/agent/payload-parser';

/** Pagination summary returned alongside list results. */
export interface OptisignsPageInfo {
  total: number;
  count: number;
  perPage: number;
  currentPage: number;
  totalPages: number;
  /** Relay cursor: pass back as `cursor` to fetch the next page (infinite scroll). */
  endCursor: string | null;
  /** Whether another page exists — gates load-more. */
  hasNextPage: boolean;
}

export interface ListOptisignsAssetsResult {
  items: OptisignsAssetItem[];
  pageInfo: OptisignsPageInfo;
}

export interface ListOptisignsFoldersResult {
  items: OptisignsFolderItem[];
  pageInfo: OptisignsPageInfo;
}

interface ListAssetsParams {
  path?: string;
  fileType?: string;
  search?: string;
  cursor?: string;
}

interface ListFoldersParams {
  path?: string;
  search?: string;
  cursor?: string;
}

/**
 * Firebase-authenticated client for the OptiSigns asset browse panel. Calls the
 * project-scoped UI endpoints (`/api/editor/projects/:id/optisigns-assets[...]`),
 * which resolve the workspace from the project and query OptiSigns on its behalf.
 */
export const optisignsAssetsApi = {
  async listAssets(
    token: string,
    projectId: string,
    params: ListAssetsParams,
  ): Promise<ListOptisignsAssetsResult> {
    const response = await apiClient.get(
      `/api/editor/projects/${projectId}/optisigns-assets`,
      { headers: createAuthHeaders(token), params },
    );
    return response.data;
  },

  async listFolders(
    token: string,
    projectId: string,
    params: ListFoldersParams,
  ): Promise<ListOptisignsFoldersResult> {
    const response = await apiClient.get(
      `/api/editor/projects/${projectId}/optisigns-assets/folders`,
      { headers: createAuthHeaders(token), params },
    );
    return response.data;
  },
};
